import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "block",
    borderRadius: 8,
    background: theme.mode === "light" ? "#f5f5f5" : "#1f1f1f",
    border: theme.mode === "light" ? "1px solid #e0e0e0" : "1px solid #333",
    maxWidth: 360,
    minWidth: 210,
    textDecoration: "none",
    color: "inherit",
    overflow: "hidden",
  },
  hero: {
    width: "100%",
    height: 150,
    objectFit: "cover",
    display: "block",
    background: theme.mode === "light" ? "#eee" : "#111",
  },
  content: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: 8,
  },
  favicon: {
    width: 34,
    height: 34,
    borderRadius: 6,
    objectFit: "cover",
    background: theme.mode === "light" ? "#fff" : "#111",
    border: theme.mode === "light" ? "1px solid #ddd" : "1px solid #222",
    flex: "none",
  },
  info: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    flex: 1,
  },
  title: {
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.25,
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  description: {
    fontSize: 11,
    color: theme.palette.text.secondary,
    lineHeight: 1.25,
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    marginTop: 2,
  },
  domain: {
    fontSize: 11,
    color: theme.palette.text.secondary,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginTop: 2,
  },
}));

const getDomain = (url) => {
  try {
    const parsed = new URL(url);
    return parsed.hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
};

const isImageUrl = (url = "") => /\.(png|jpg|jpeg|gif|webp)(\?.*)?$/i.test(url);

const getFavicon = (url) => {
  const domain = getDomain(url);
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=64`;
};

const LinkPreview = ({ url, title, description, image }) => {
  const classes = useStyles();
  const domain = getDomain(url);
  const hero = image || (isImageUrl(url) ? url : null);

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className={classes.card}>
      {hero && <img src={hero} alt="" className={classes.hero} />}
      <div className={classes.content}>
        {!hero && <img src={getFavicon(url)} alt="" className={classes.favicon} />}
        <div className={classes.info}>
          <span className={classes.title}>{title || domain}</span>
          {description && (
            <span className={classes.description}>{description}</span>
          )}
          <span className={classes.domain}>{domain}</span>
        </div>
      </div>
    </a>
  );
};

export default LinkPreview;
